module.exports = __webpack_public_path__ + "img/picture_ningbo.c82b8623.jpg";